import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  icon: '⚙️',
  title: 'Automatización de\u00a0procesos'
}, {
  icon: '👥',
  title: 'CRM — Gestión de\u00a0clientes'
}, {
  icon: '💻',
  title: 'Asistencia virtual'
}, {
  icon: '📈',
  title: 'Sistemas para\u00a0escalar'
}];
export function AlliancesSection() {
  return <section className="py-20 md:py-24 bg-gradient-to-b from-inkova-light to-white overflow-hidden" data-id="element-91">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-93">
          <span className="inline-block bg-inkova-accent/20 text-inkova-accent text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6" data-id="element-94">
            Alianzas Estratégicas
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-2" data-id="element-95">
            Tu negocio no crece&nbsp;solo.
          </h2>
          <p className="text-2xl md:text-3xl font-serif font-bold text-inkova-primary" data-id="element-96">
            Crece con el equipo&nbsp;correcto.
          </p>
          <p className="text-gray-600 font-light mt-4 max-w-2xl mx-auto" data-id="element-97">
            En Inkova trabajamos con aliados estratégicos especializados para
            que tu negocio opere con estructura real desde
            el&nbsp;primer&nbsp;día.
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12" data-id="element-98">
          {services.map((s, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center hover:shadow-md transition-shadow" data-id="element-99">
              <span className="text-4xl mb-3 block" data-id="element-100">{s.icon}</span>
              <h4 className="text-sm md:text-base font-bold text-gray-900" data-id="element-101">
                {s.title}
              </h4>
            </div>)}
        </motion.div>

        {/* Optic360 Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-inkova-primary rounded-2xl p-8 md:p-10 text-center shadow-xl" data-id="element-102">
          <p className="text-inkova-accent font-bold text-2xl md:text-3xl font-serif mb-2" data-id="element-103">
            Opti360 Intelligent Systems
          </p>
          <p className="text-white/80 text-sm font-light mb-6" data-id="element-104">
            Aliado principal en automatización y&nbsp;CRM
          </p>
          <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20c%C3%B3mo%20integrar%20automatizaci%C3%B3n%20y%20CRM%20en%20mi%20negocio%20con%20Optic360" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-inkova-accent text-inkova-primary font-bold text-base hover:bg-white transition-colors duration-300 shadow-lg" data-id="element-105">
            Quiero saber cómo integrar estas&nbsp;herramientas
          </a>
        </motion.div>
      </div>
    </section>;
}